import gql from 'graphql-tag';

const REMOVE_CLASSROOMS = gql`
  mutation removeClassrooms($where: ClassroomsWhereInput!) {
    removeClassrooms(where: $where) {
      count
    }
  }
`;

export default REMOVE_CLASSROOMS;
